import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import {
  InfoBlockRow,
  InfoBlockRowWithSubInfo,
} from '@/modules/drivers/shared/InfoBlocks'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const TimeData = () => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-flex-col tw-gap-8 tw-p-5 tw-pt-6 lg:tw-flex-row">
      <div className="tw-flex tw-w-full tw-max-w-[500px] tw-flex-col tw-gap-4">
        <div className="flex-1 tw-flex tw-w-full tw-flex-col tw-gap-2.5 lg:tw-max-w-[450px]">
          <p className="tw-text-xl tw-font-semibold tw-text-content-base">
            {t('driverModule.current-rest-time')}
          </p>
          <InfoBlockRow label={t('driverModule.daily')} lines={[20]} />
          <InfoBlockRow label={t('driverModule.weekly')} lines={[20]} />
          <InfoBlockRow label={t('driverModule.compensations')} lines={[20]} />
          <DividerHorizontal />
        </div>
        <div className="tw-flex tw-w-full tw-flex-1 tw-flex-col tw-gap-2.5 lg:tw-max-w-[450px]">
          <p className="tw-text-xl tw-font-semibold tw-text-content-base">
            {t('driverModule.deadlines')}
          </p>
          <InfoBlockRowWithSubInfo
            label={t('driverModule.daily-rest-start')}
            subLabel={t('driverModule.at-latest')}
            lines={['28.05.2025 22:32']}
          />
          <InfoBlockRowWithSubInfo
            label={t('driverModule.weekly-rest-start')}
            subLabel={t('driverModule.at-latest')}
            lines={['24.06.2023 14:26']}
          />
          <DividerHorizontal />
        </div>
      </div>
      <div className="tw-flex tw-w-full tw-max-w-[500px] tw-flex-col tw-gap-4">
        <div className="tw-flex tw-w-full tw-flex-1 tw-flex-col tw-gap-2.5 lg:tw-max-w-[450px]">
          <p className="tw-text-xl tw-font-semibold tw-text-content-base">
            {t('driverModule.remaining-driving-time')}
          </p>
          <InfoBlockRow label={t('driverModule.daily')} lines={['08:10 z 10:00']} />
          <InfoBlockRow label={t('driverModule.continuous')} lines={['01.03 z 04:30']} />
          <InfoBlockRow
            label={t('driverModule.weekly')}
            lines={['31:25', '(do niedzieli 01.06.2025 23:59)']}
          />
          <InfoBlockRow
            label={t('driverModule.biweekly')}
            lines={['31:25 (31:25)', '(do niedzieli 01.06.2025 23:59)']}
          />

          <DividerHorizontal />
        </div>
        <div className="flex-1 tw-flex tw-w-full tw-flex-col tw-gap-2.5 lg:tw-max-w-[450px]">
          <p className="tw-text-xl tw-font-semibold tw-text-content-base">
            {t('driverModule.remaining-allowances')}
          </p>
          <InfoBlockRow lines={[t('driverModule.driving-extensions-10h')]} />
          <InfoBlockRow lines={[t('driverModule.rest-reductions-9h')]} />
          <DividerHorizontal />
        </div>
      </div>
    </div>
  )
}

export default TimeData
